import React from 'react';

const sizeMap = {
  sm: 'text-sm font-bold',
  xs: 'text-2sm font-semibold',
};

/**
 * Inline text-link styled button (primary color + underline on hover).
 * @param {'sm'|'xs'} size - sm (14px bold) or xs (13px semibold)
 * @param {string} className - extra layout classes (shrink-0, self-start, etc.)
 */
export default function LinkButton({ onClick, size = 'sm', className = '', children }) {
  return (
    <button
      onClick={onClick}
      className={`${sizeMap[size] || sizeMap.sm} text-orange-500 hover:underline ${className}`.trim()}
    >
      {children}
    </button>
  );
}
